// extracted by mini-css-extract-plugin
export default {"buy_token_card_corner_bg":"token_buy_token_card_corner_bg__yry9R"};